import { getApiEndpoint } from '~/api/auth';
import type { Project, Promocode } from '~/api/types.ts';
import { authFetch } from '~/api/utils';
import type { User, UserCreateDeleteRequestProps } from './types';

export const getUser = async (): Promise<User> => {
  return await authFetch(getApiEndpoint() + 'user');
};

export const getUserProjects = async (): Promise<Project[]> => {
  return await authFetch(getApiEndpoint() + 'user/projects/', {
    method: 'GET',
  });
};

export const changeEmail = async ({ email }: { email: string }) => {
  return await authFetch(getApiEndpoint() + 'user/email/', {
    method: 'POST',
    body: {
      email,
    },
  });
};

export const createDeleteRequest = async ({ reason }: UserCreateDeleteRequestProps) => {
  return await authFetch<{ promocode: Promocode }>(getApiEndpoint() + 'user/deleteRequest/create', {
    method: 'POST',
    body: { reason },
  });
};

export const revertDeleteRequest = async () => {
  return await authFetch(getApiEndpoint() + `user/deleteRequest/delete`, {
    method: 'POST',
  });
};

export const approveDeleteRequest = async () => {
  return await authFetch(getApiEndpoint() + `user/deleteRequest/approve`, {
    method: 'POST',
  });
};
